"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const b_1 = __importDefault(require("b_"));
const react_1 = require("react");
const dialog_polyfill_1 = __importDefault(require("dialog-polyfill"));
const image_modal_styles_1 = __importDefault(require("./image-modal.styles"));
const b = b_1.default.with('image-modal');
const MAX_MODAL_WIDTH_PERCENTAGE = 80;
const MAX_MODAL_HEIGHT_PERCENTAGE = 90;
const MOBILE_MAX_WIDTH = 640;
function ImageModal({ showModal, setShowModal, url }) {
    const ref = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    const [isPolyfill, setIsPolyfill] = (0, react_1.useState)(false);
    const [zoom, setZoom] = (0, react_1.useState)(false);
    const [isVertical, setIsVertical] = (0, react_1.useState)(false);
    const [isFitForContainer, setIsFitForContainer] = (0, react_1.useState)(false);
    const { current: container } = containerRef;
    (0, react_1.useEffect)(() => {
        if (zoom && container && document.body.clientWidth <= MOBILE_MAX_WIDTH) {
            container.scrollTop = (container.scrollHeight - container.clientHeight) / 2;
            container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
        }
    }, [zoom, container]);
    const resetModal = () => {
        setZoom(false);
        setShowModal(false);
    };
    (0, react_1.useEffect)(() => {
        const dialog = ref.current;
        if (typeof HTMLDialogElement !== 'function') {
            dialog_polyfill_1.default.registerDialog(dialog);
            setIsPolyfill(true);
        }
        if (showModal) {
            dialog.showModal();
        }
        else {
            // Костыль для бага
            // "Error: Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed." in safari and FF
            // https://github.com/GoogleChrome/dialog-polyfill/issues/221
            onModalClose(dialog);
        }
    }, [showModal, ref.current]);
    (0, react_1.useEffect)(() => {
        const dialog = ref.current;
        function onCloseHandler() {
            resetModal();
            onModalClose(dialog);
        }
        dialog.addEventListener('close', onCloseHandler);
        return () => {
            dialog.removeEventListener('close', onCloseHandler);
        };
    }, []);
    const handleImageLoad = (e) => {
        const image = e.target;
        const { naturalWidth, naturalHeight } = image;
        const { clientWidth, clientHeight } = document.body;
        const isVerticalImage = naturalWidth < naturalHeight;
        const isSquareImage = naturalHeight === naturalWidth;
        const canFit = canImageFitInContainer({ imageWidth: naturalWidth, imageHeight: naturalHeight }, { clientWidth, clientHeight });
        if (isVerticalImage) {
            setIsVertical(true);
        }
        if (!canFit) {
            setIsFitForContainer(false);
        }
        if (naturalWidth <= clientWidth * (MAX_MODAL_WIDTH_PERCENTAGE / 100)) {
            setIsFitForContainer(true);
        }
        if (isSquareImage && !canFit) {
            setIsVertical(true);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("dialog", Object.assign({ ref: ref, css: image_modal_styles_1.default, onClick: () => resetModal(), className: b('dialog', { isPolyfill }) }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('icons') }, { children: [!isFitForContainer && ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: b('zoom-container'), onClick: e => {
                            e.stopPropagation();
                            setZoom(prev => !prev);
                        } }, { children: zoom ? ((0, jsx_runtime_1.jsx)("div", { className: b('zoom-out') })) : ((0, jsx_runtime_1.jsx)("div", { className: b('zoom-in') })) }))), (0, jsx_runtime_1.jsx)("div", { className: b('cross') })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper', { zoom, isPolyfill }), ref: containerRef }, { children: (0, jsx_runtime_1.jsx)("img", { src: url, className: b('image', { zoom, isVertical }), onLoad: handleImageLoad, onClick: e => e.stopPropagation() }) }))] })));
}
exports.default = ImageModal;
function canImageFitInContainer(image, container) {
    const { imageHeight, imageWidth } = image;
    const { clientWidth, clientHeight } = container;
    return (imageWidth <= clientWidth * (MAX_MODAL_WIDTH_PERCENTAGE / 100) &&
        imageHeight <= clientHeight * (MAX_MODAL_HEIGHT_PERCENTAGE / 100));
}
function onModalClose(dialog) {
    try {
        dialog.close();
    }
    catch (_a) {
        dialog.open = false;
    }
}
